import { NgModule, APP_INITIALIZER } from '@angular/core';
import { currencyInitFactory, CurrencyInitService } from '@core/services';


@NgModule({
    imports: [],
    declarations: [],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: currencyInitFactory,
            deps: [CurrencyInitService],
            multi: true,
        },
    ],
})
export class InitModule {}
